import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './styles.scss';
import Constants from '../../../../constants/constants';
import FilterCard from '../FilterCard/FilterCard';
import FilterSetCard from '../FilterSetCard/FilterSetCard';
import Input from '../../../shared/Input/Input';
import filtersUtil from '../../../../utils/filters/filtersUtil';
import Tabs from '../../../shared/Tabs/Tabs';
import Features from '../../../../features';
import UpgradeBadge from '../../../shared/UpgradeBadge/UpgradeBadge';
import Tooltip from '../../../shared/Tooltip/Tooltip';
import { featureAdvertExists } from '../../../shared/Feature/featureUtil';
import GuidanceTip from '../../../shared/GuidanceTip/GuidanceTip';
import Button from '../../../shared/Button/Button';

/*
 * we tried PureComponent and the issue we got is
 * after changing an alias of a selectedExtension
 * on the header of avaliableFields, it wasn't changed
 */
class AvailableFields extends Component {
  constructor(props) {
    super(props);
    const { selectedDataExtensions, filterSets } = this.props;

    this.state = {
      filterSearchField: '',
      isFilterFieldsTabSelected: true,
      expandFields: false,
      currentSelectedDataExtensions: selectedDataExtensions,
      expandClicked: false,
      collapseClicked: false,
      toggleSingleSelection: false,
      toggledSelection: false,
      groupedFilterSets: filterSets ?
        filtersUtil.getGroupedFilterSetsToDisplay(filterSets, selectedDataExtensions) :
        [],
    };
    this.featureCustomValues = Features.isFeatureEnabled(
      Constants.FEATURE__CUSTOM_VALUES,
    );
  }
  /**
   * update component when a new Extension is added
   * @param {*} prevProps - Previous props
   */

  async componentDidUpdate(prevProps) {
    const { selectedDataExtensions, createNewAutoTargetDE, filterSets } = this.props;

    if(selectedDataExtensions && selectedDataExtensions.length !== prevProps.selectedDataExtensions.length) {
      this.setState({
        currentSelectedDataExtensions: selectedDataExtensions,
        groupedFilterSets: filtersUtil.getGroupedFilterSetsToDisplay(filterSets, selectedDataExtensions),
      });
    }
    if(prevProps?.createNewAutoTargetDE !== createNewAutoTargetDE && createNewAutoTargetDE) {
      this.handleExpand(false);
    }
  }

  /**
   * Set state filterSearchField
   * @param {object} e - event
   * @returns {void}
   */
  handleFilterSearchField = (e) => {
    const {
      expandClicked, toggleSingleSelection, collapseClicked, currentSelectedDataExtensions, toggledSelection,
    } = this.state;

    this.setState({ filterSearchField: e.target.value });
    if(currentSelectedDataExtensions.length > 1) {
      if (e.target.value) {
        this.handleExpand(true);
        this.handleExpandFilterSets(true);
      } else {
        if(expandClicked) {
          this.handleExpand(true);
          this.handleExpandFilterSets(true);
        } else if (collapseClicked) {
          this.handleExpand(false);
          this.handleExpandFilterSets(false);
        }else {
          this.handleExpand(false);
          this.handleExpandFilterSets(false);
        }
      }
    } else {
      if (e.target.value) {
        this.handleExpand(true);
        this.handleExpandFilterSets(true);
      } else {
        if(toggleSingleSelection && toggledSelection) {
          this.handleExpand(true);
          this.handleExpandFilterSets(true);
        }else if (!toggleSingleSelection && toggledSelection) {
          this.handleExpand(false);
          this.handleExpandFilterSets(false);
        }else {
          this.handleExpand(false);
          this.handleExpandFilterSets(false);
        }
      }
    }
  };
  /**
   * Toggle dataExtensions
   * @param {*} dataExtensionId - this is dataExtension deAlias
   * @param {*} index - this is the position of the DataExtension
   */

  toggleFieldsVisibility = (dataExtensionId, index) => {
    const { currentSelectedDataExtensions } = this.state;

    this.setState(state => ({
      ...state,
      currentSelectedDataExtensions: state?.currentSelectedDataExtensions?.map((data, i) => {
        if (data.deAlias === dataExtensionId && index === i && data.showFields) {
          return {
            ...data,
            showFields: false,
          };
        }
        if (data.deAlias === dataExtensionId && index === i && !data.showFields) {
          return {
            ...data,
            showFields: true,
          };
        }

        return data;
      }) || [],
    }));

    if(currentSelectedDataExtensions?.length === 1) {
      if(currentSelectedDataExtensions[0].showFields) {
        this.setState({ toggleSingleSelection: false, toggledSelection: true });
      }else {
        this.setState({ toggleSingleSelection: true, toggledSelection: true });
      }
    }
  };

  /**
   * Set state expandFields and visibleFieldsDEId
   * @param {*} data - if expand data will be true if collapse data will be false
   */

  handleExpand = (data) => {
    if (data) {
      this.setState(state => ({
        ...state,
        currentSelectedDataExtensions: state.currentSelectedDataExtensions.map((data) => {
          return {
            ...data,
            showFields: true,
          };
        }),
      }));
    } else {
      this.setState(state => ({
        ...state,
        currentSelectedDataExtensions: state.currentSelectedDataExtensions.map((data) => {
          return {
            ...data,
            showFields: false,
          };
        }),
      }));
    }
  };

  /**
   * Expand and collapse filter sets fields
   * @param {boolean} status - if expand status will be true if collapse status will be false
   */

  handleExpandFilterSets = (status) => {
    if (status) {
      this.setState(state => ({
        ...state,
        groupedFilterSets: state.groupedFilterSets.map((data) => {
          return {
            ...data,
            showFilterSetFields: true,
          };
        }),
      }));
    } else {
      this.setState(state => ({
        ...state,
        groupedFilterSets: state.groupedFilterSets.map((data) => {
          return {
            ...data,
            showFilterSetFields: false,
          };
        }),
      }));
    }
  };
  /**
   * Toggle filter sets visibility
   * @param {string} name - name of category
   * @param {boolean} status - visibility status
   * @param {number} index - position of category in array
   */

  toggleFilterSetsVisibility = (name, status, index) => {
    this.setState(state => ({
      ...state,
      groupedFilterSets: state?.groupedFilterSets?.map((data, i) => {
        if (data.category.name === name && index === i) {
          return {
            ...data,
            showFilterSetFields: !status,
          };
        }

        return data;
      }) || [],
    }));
  };

  render() {
    const {
      selectedDataExtensions,
      handleAddFieldToTargetDE,
      editNewAutoTargetDE,
      newTargetDataExtensionFields,
      handleSetSelectionState,
      matchedFields,
      dropToTargetDataExtensionField,
      manageSubscriberRelationship,
      customValues,
      editTargetDataExtension,
      targetDataExtensionFields,
      DEBorderMouseOver,
      filterBorderMouseOver,
      hideCollectionAlias,
      inTargetDefinition,
      filterSets,
      showFilterSets,
      isBasicMode,
      globalCustomValues,
      showEssentialsUpgradeModal,
    } = this.props;

    const availableFieldsTitle = showFilterSets || !inTargetDefinition ? 'Available Filters' : 'Available Fields';

    const fieldsHeaderTitle = customValues === undefined ? availableFieldsTitle : 'Custom Values';

    const
      {
        filterSearchField, isFilterFieldsTabSelected, currentSelectedDataExtensions, expandFields, groupedFilterSets,
      } = this.state;

    const customValuesFeatureDisabled = !this.featureCustomValues && customValues !== undefined;

    const expandCollapse = (
      <div>
       <div
       className="expand-collapse-container"
       >
         <Button
           buttonLook={Constants.BUTTON__TYPE__NEUTRAL}
           className="slds-button ml-4px"
           id="expandAll"
           title="Expand All"
           onClick={() => {
             this.setState({ expandClicked: true, collapseClicked: false });
             this.handleExpand(true);
           }}
         >
           Expand All
           <span className="filter-icon-padding ml-4px">
             <i
               className="fas fa-angle-double-down"
             />
           </span>
         </Button>
         <Button
           buttonLook={Constants.BUTTON__TYPE__NEUTRAL}
           id="collapseAll"
           className="slds-button mr-4px"
           title="Collapse All"
           onClick={() => {
             this.setState({ expandClicked: false, collapseClicked: true });
             this.handleExpand(false);
           }}
         >
           Collapse All
          <span className="filter-icon-padding ml-4px">
             <i
               className="fas fa-angle-double-up"
             />
          </span>
         </Button>
       </div>
      </div>
    );
    const expandCollapseFilterSets = (
      <div>
       <div
       className="expand-collapse-container"
       >
         <Button
           buttonLook={Constants.BUTTON__TYPE__NEUTRAL}
           className="slds-button ml-4px"
           id="expandAll"
           title="Expand All"
           onClick={() => {
             this.handleExpandFilterSets(true);
           }}
         >
           Expand All
           <span className="filter-icon-padding ml-4px">
             <i
               className="fas fa-angle-double-down"
             />
           </span>
         </Button>
         <Button
           buttonLook={Constants.BUTTON__TYPE__NEUTRAL}
           id="collapseAll"
           className="slds-button mr-4px"
           title="Collapse All"
           onClick={() => {
             this.handleExpandFilterSets(false);
           }}
         >
           Collapse All
          <span className="filter-icon-padding ml-4px">
             <i
               className="fas fa-angle-double-up"
             />
          </span>
         </Button>
       </div>
      </div>
    );

    let filterCard = null;

    if (currentSelectedDataExtensions && currentSelectedDataExtensions.length > 0) {
      filterCard = (
        <div>
        {currentSelectedDataExtensions.map((dataExtension, index) => (
          <FilterCard
            hideCollectionAlias={!!hideCollectionAlias}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            positionIndex={index}
            dataExtension={dataExtension}
            filterSearchField={filterSearchField}
            handleAddFieldToTargetDE={handleAddFieldToTargetDE}
            editNewAutoTargetDE={editNewAutoTargetDE}
            newTargetDataExtensionFields={newTargetDataExtensionFields}
            handleSetSelectionState={handleSetSelectionState}
            selectedDataExtensions={selectedDataExtensions}
            matchedFields={matchedFields}
            dropToTargetDataExtensionField={dropToTargetDataExtensionField}
            manageSubscriberRelationship={manageSubscriberRelationship}
            editTargetDataExtension={editTargetDataExtension}
            targetDataExtensionFields={targetDataExtensionFields}
            DEBorderMouseOver={DEBorderMouseOver}
            filterBorderMouseOver={filterBorderMouseOver}
            inTargetDefinition={inTargetDefinition}
            isBasicMode={isBasicMode}
            showFields={currentSelectedDataExtensions[index].showFields}
            toggleFieldsVisibility={this.toggleFieldsVisibility}
            showEssentialsUpgradeModal={showEssentialsUpgradeModal}
            expandFields={expandFields}
          />
        ))}
        </div>
      );
    } else if (customValues === undefined) {
      filterCard = null;
    } else {
      filterCard = (
        <FilterCard
          hideCollectionAlias={!!hideCollectionAlias}
          customValues={customValues}
          filterSearchField={filterSearchField}
          handleAddFieldToTargetDE={handleAddFieldToTargetDE}
          editNewAutoTargetDE={editNewAutoTargetDE}
          dropToTargetDataExtensionField={dropToTargetDataExtensionField}
          matchedFields={matchedFields}
          handleSetSelectionState={handleSetSelectionState}
          DEBorderMouseOver={DEBorderMouseOver}
          toggleFieldsVisibility={this.toggleFieldsVisibility}
          globalCustomValues={globalCustomValues}
          showEssentialsUpgradeModal={showEssentialsUpgradeModal}
          expandFields={expandFields}
        />
      );
    }

    let filterSetsCard = null;

    if (groupedFilterSets?.length > 0) {
      filterSetsCard = (
        groupedFilterSets.map((groupedSet, index) => (
        <FilterSetCard
          key={index}
          positionIndex={index}
          hideCollectionAlias={!!hideCollectionAlias}
          filterSetsToDisplay={groupedSet}
          filterSets={filterSets}
          filterSearchField={filterSearchField}
          handleAddFieldToTargetDE={handleAddFieldToTargetDE}
          editNewAutoTargetDE={editNewAutoTargetDE}
          newTargetDataExtensionFields={newTargetDataExtensionFields}
          handleSetSelectionState={handleSetSelectionState}
          selectedDataExtensions={selectedDataExtensions}
          matchedFields={matchedFields}
          dropToTargetDataExtensionField={dropToTargetDataExtensionField}
          manageSubscriberRelationship={manageSubscriberRelationship}
          editTargetDataExtension={editTargetDataExtension}
          toggleFilterSetsVisibility={this.toggleFilterSetsVisibility}
          targetDataExtensionFields={targetDataExtensionFields}
          DEBorderMouseOver={DEBorderMouseOver}
          filterBorderMouseOver={filterBorderMouseOver}
          inTargetDefinition={inTargetDefinition}
        />
        ))
      );
    }

    return (
      <div className={`available-fields ${!!inTargetDefinition}`}>
        <h4 className="section-title">
          { fieldsHeaderTitle }
          {
            !customValues &&
            <GuidanceTip
              tipId={showFilterSets || !inTargetDefinition ? 'available-filters-tip' : 'available-fields-tip'}
              toolTipPosition="right"
            />
          }
          {
          customValuesFeatureDisabled &&
            (featureAdvertExists(Constants.FEATURE__CUSTOM_VALUES) ?
            <div onClick={() => showEssentialsUpgradeModal(Constants.FEATURE__CUSTOM_VALUES)}>
              <UpgradeBadge />
            </div> :
            <div className="unavailable-feature-tooltip">
              <Tooltip
              nubbinPosition={Constants.NUBBIN_POSITION__TOP_RIGHT}
              type={Constants.TOOLTIP_TYPE__UNAVAILABLE_FEATURE}
              />
            </div>)
          }
        </h4>
        <div className="available-fields_input_wrapper">
          {
            customValuesFeatureDisabled &&
            <div
              onClick={() => showEssentialsUpgradeModal(Constants.FEATURE__CUSTOM_VALUES)}
              className="disabled-overlay-cv"
            />
          }
          <Input
            className={'field-search' + (customValues === undefined ? '' : ' customValues')}
            noInputClassName
            placeholder={customValues === undefined ? 'Search fields' : 'Search values'}
            onChange={e => this.handleFilterSearchField(e)}
            />
          <div className="available-fields_input_wrapper_icon_wrapper">
            <span className="slds-icon_container slds-icon-utility-announcement">
              <svg className="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                <use xlinkHref="/assets/icons/utility-sprite/svg/symbols.svg#search" />
              </svg>
            </span>
          </div>
        </div>
        <div
          className={classNames('make-space-for-scroll h-17rem', {
            'disabled-cv': customValuesFeatureDisabled,
          })}
          >
        {
          customValuesFeatureDisabled &&
          <div
              onClick={() => showEssentialsUpgradeModal(Constants.FEATURE__CUSTOM_VALUES)}
              className="disabled-overlay-cv"
            />
        }
        {(showFilterSets === true || showFilterSets === false) && (
          <Tabs
              tabs={[
                {
                  name: 'Filter Fields',
                },
                {
                  name: 'Filter Sets',
                  disabled: !showFilterSets,
                  tooltipType: showFilterSets ?
                    Constants.FEATURE__FILTER_SETS :
                    Constants.TOOLTIP_TYPE__UNAVAILABLE_FEATURE,
                  feature: Constants.FEATURE__FILTER_SETS,
                },
              ]}
              changeTab={tabName => this.setState({ isFilterFieldsTabSelected: tabName === 'Filter Fields' })}
              active={isFilterFieldsTabSelected ? 'Filter Fields' : 'Filter Sets'}
              showEssentialsUpgradeModal={showEssentialsUpgradeModal}
            />
        )}
        <div>
          {
          isFilterFieldsTabSelected && !isBasicMode && selectedDataExtensions && selectedDataExtensions.length > 1 ?
            expandCollapse :
            ''
          }
          {
          !isFilterFieldsTabSelected && filterSets.length > 1 ?
            expandCollapseFilterSets :
            ''
          }
        </div>
          <div
            id="fields"
            className="available-fields_available_collections"
          >
            {isFilterFieldsTabSelected ? filterCard : filterSetsCard}
          </div>
        </div>
      </div>
    );
  }
}

AvailableFields.propTypes = {
  /**
   * It keeps the selected data extensions for Selection.js
   * selected data extensions are stored as collections in database
   * It will be passed from Selection.js
   */
  selectedDataExtensions: PropTypes.instanceOf(Array),
  /**
   * It helps to a new field to a DE while creating one
   */
  handleAddFieldToTargetDE: PropTypes.func,
  /**
   * It keeps the value of AC/DE creation status
   * It will be passed from Selection.js
   */
  editNewAutoTargetDE: PropTypes.bool,
  /**
   * It keeps the fields of a new target data extension while creating one
   */
  newTargetDataExtensionFields: PropTypes.instanceOf(Array),
  /**
   * It helps to set the Selection`s state
   * It will be passed from Selection.js
   */
  handleSetSelectionState: PropTypes.func.isRequired,
  /**
   * It keeps the matchedFields for a target data extension of the Selection
   * It will be passed from Selection.js
   */
  matchedFields: PropTypes.instanceOf(Array),
  /**
   * It helps to match a field between available fields and target DE fields
   */
  dropToTargetDataExtensionField: PropTypes.func,
  /**
   * It helps to manage subscriber relationship while creating a data extension
   * It will be passed from Selection.js
   */
  manageSubscriberRelationship: PropTypes.func,
  /**
   * boolean state from Selection for going in or out the edit target de mode
   */
  editTargetDataExtension: PropTypes.bool,
  /**
   * It keeps the fields of an existing target data extension
   * It will be passed from Selection.js
   */
  targetDataExtensionFields: PropTypes.instanceOf(Array),
  /*
   * Keeps track whether Available DE are dragged
   */
  DEBorderMouseOver: PropTypes.bool.isRequired,
  /**
   * Keeps track whether Available Fields are dragged
   */
  filterBorderMouseOver: PropTypes.bool.isRequired,
  /**
   * It keeps custom values data
   * It will be passed from Selection.js
   */
  customValues: PropTypes.instanceOf(Array),
  /**
   * It determines if the collection alias should be hidden after the name in the filter line
   */
  hideCollectionAlias: PropTypes.bool.isRequired,
  /**
   * Defines whether the component is used in Target Definition view
   */
  inTargetDefinition: PropTypes.bool,
  /**
   * An array containing filter sets
   */
  filterSets: PropTypes.instanceOf(Array),
  /**
   * Define whether filter sets should be shown or not
   */
  showFilterSets: PropTypes.bool,
  /**
   * Indicates whether a selection is in basic mode
   */
  isBasicMode: PropTypes.bool,
  /**
   * Shared Custom Values defined for this BU
   */
  globalCustomValues: PropTypes.instanceOf(Array),
  /**
   * It toggles a feature advert modal on with specific feature
   */
  showEssentialsUpgradeModal: PropTypes.func,
  /**
   * Determines if a new DE is being created
   */
  createNewAutoTargetDE: PropTypes.bool,
};

export default AvailableFields;
